"use client";
import {
  input_otp_default
} from "./chunk-IUEDQH4S.mjs";
import "./chunk-RYJJWGYI.mjs";
import "./chunk-5NWQAIF7.mjs";
import {
  useInputOtp
} from "./chunk-3JLK3F7W.mjs";

// src/index.ts
import { REGEXP_ONLY_DIGITS, REGEXP_ONLY_CHARS, REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";
export {
  input_otp_default as InputOtp,
  REGEXP_ONLY_CHARS,
  REGEXP_ONLY_DIGITS,
  REGEXP_ONLY_DIGITS_AND_CHARS,
  useInputOtp
};
